import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";
import AppStack from "./AppStack";
import AuthStack from "./AuthStack";
import ErrorPage from "../component/views/ErrorPage";
import EditProfile from "../screens/EditProfile";
import FirstLoginStack from "./FirstLoginStack";
import { UserRole } from "../constants/enum/UserRole";
import { useEffect } from "react";
import { STUDENT_REDIRECT } from "../constants/consts";
import { authSlice } from "../services/stores/auth/slice";

//* Hooks imports
import { useDispatch, useSelector } from "react-redux";
import { useAuthPersistence } from "../hooks/useAuthPersistence";
import { useAuthCacheManager } from "../hooks/useAuthCacheManager";

//* Components imports
import { Loading } from "../component/common/Loading";

//* Process imports
import ProcessList from "../screens/ProcessView/list/index";
import ProcessView from "../screens/ProcessView/view";
import ProcessExamList from "../screens/ProcessView/exam-list/index";
import ProcessEditalView from "../screens/ProcessView/edital/index";

//* Resource imports
import ResourceList from "../screens/ResourceView/list/index";
import ResourceQuestionForm from "../screens/ResourceView/form/question/index";

//* Essay imports
import ProcessEssayList from "../screens/EssayView/list/index";
import EssayView from "../screens/EssayView/view/index";

//* Result imports
import ResultView from "../screens/ResultView/view/index";

//* Enrollment imports
import EnrollmentView from "../screens/EnrollmentView/view/index";

export const { logout, clearRedirectFlag } = authSlice.actions;

export function RedirectPage() {
  const dispatch = useDispatch();
  const { me } = useSelector((store: any) => store.auth);

  useEffect(() => {
    if (me?.role?.slug === UserRole.STUDENT_USER) {
      setTimeout(() => {
        window.location.replace(STUDENT_REDIRECT as string);
        return dispatch(logout(""));
      }, 5000);
    }
  }, [dispatch, me?.role?.slug]);

  return (
    <p
      style={{
        margin: "0px 0px 0.35em",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "2.125rem",
        lineHeight: 1.235,
        letterSpacing: "0.00735em",
        fontWeight: 700,
        textAlign: "center",
      }}
    >
      <br />
      <br />
      Essa plataforma é para uso exclusivo de professores e colaboradores da
      instituição.
      <br />
      <br />
      Você será redirecionado para a área do aluno.
    </p>
  );
}

export default function AppNav() {
  // Use the custom hook to handle auth persistence
  const { logged, loading } = useAuthPersistence();
  const { blank, status, me } = useSelector((store: any) => store.auth);

  // Automatically manage React Query cache based on auth state
  useAuthCacheManager();

  if (loading) {
    return <Loading message="Carregando..." />;
  }

  function Root() {
    // More robust user verification
    const isUserValid = me && me.id !== null && me.id !== undefined;

    if (!logged) {
      return <AuthStack />;
    }

    if (blank === true) {
      return <Outlet />;
    }

    if (!isUserValid) {
      return <AuthStack />;
    }

    if (status === "CREATED" || !status) {
      return <FirstLoginStack />;
    }

    if (me.role?.slug === UserRole.STUDENT_USER) {
      return <RedirectPage />;
    }

    return <AppStack />;
  }

  const router = createBrowserRouter([
    {
      path: "*",
      element: <Root />,
      errorElement: <ErrorPage />,
      children:
        blank === false
          ? [
              //? Rotas Públicas
              {
                path: "edit-profile",
                element: <EditProfile />,
              },
              //! Rotas Protegidas
              {
                path: "",
                element: <ProcessList />,
              },
              {
                path: "process/:id",
                element: <ProcessView />,
              },
              {
                path: "process/:id/exam",
                element: <ProcessExamList />,
              },
              {
                path: "process/:id/resource",
                element: <ResourceList />,
              },
              {
                path: "process/:id/edital",
                element: <ProcessEditalView />,
              },
              {
                path: "process/:id/resource/question",
                element: <ResourceQuestionForm />,
              },
              {
                path: "process/:id/resource/question/edit/:questionId",
                element: <ResourceQuestionForm />,
              },
              {
                path: "process/:id/exam/results/:resultId",
                element: <ResultView />,
              },
              {
                path: "process/:id/essay",
                element: <ProcessEssayList />,
              },
              {
                path: "process/:id/essay/results/:essayId",
                element: <EssayView />,
              },
              {
                path: "process/:id/enrollment",
                element: <EnrollmentView />,
              },
            ]
          : [],
    },
  ]);
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
}
